import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { DealPreviewStyled } from '../DealPreviewStyled';
import { rem } from 'polished';

export const DealPreviewStyledAC = styled(DealPreviewStyled)`
    .step-container {
        .icon {
            &.ok {
                background: ${({ theme }) => theme.colors.orange1};
                border: 3px solid ${({ theme }) => theme.colors.orange1};
            }
        }
    }

    .deal {
        border: none;
        background: ${({ theme }) => theme.colors.white};
        .deal-content {
            &__order-data {
                padding: ${rem(10)} ${rem(20)};
                font-size: ${rem(14)};
                margin-bottom: 0;

                @media (min-width: ${breakpoints.xs}px) {
                    padding: ${rem(10)} ${rem(30)};
                }
                &--date,
                &--order-number {
                    font-family: ${({ theme }) => theme.fonts.fontBase};
                    font-size: ${({ theme }) => theme.fontSizes.h6};
                    color: ${({ theme }) => theme.colors.grey5};
                }
            }
            .car-header {
                text-transform: uppercase;
                @media (min-width: ${rem(500)}) {
                    padding-top: ${rem(24)};
                }

                .car-title {
                    color: ${({ theme }) => theme.colors.grey5};
                    font-size: ${rem(22)};
                    font-weight: bold;
                    font-family: ${({ theme }) => theme.fonts.fontBase};
                }

                .price-container {
                    .price {
                        font-weight: bold;
                        color: ${({ theme }) => theme.colors.grey5};
                        font-size: ${({ theme }) => theme.fontSizes.h4} !important;
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                    }
                }

                .title-engineInfo {
                    color: ${({ theme }) => theme.colors.grey5};
                    font-family: ${({ theme }) => theme.fonts.fontBase};
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                }

                .price-and-date {
                    .date {
                        padding-right: 0;
                        font-size: ${({ theme }) => theme.fontSizes.h5};
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                        span {
                            font-weight: normal;
                            text-transform: initial;
                            color: ${({ theme }) => theme.colors.grey1};
                            font-family: ${({ theme }) => theme.fonts.fontBase};
                            font-size: ${({ theme }) => theme.fontSizes.h6};
                        }

                        .date-clock-icon {
                            svg {
                                width: ${rem(14)};
                                height: ${rem(14)};
                            }
                        }
                    }
                    .date-container {
                        text-align: right;
                        .text {
                            color: ${({ theme }) => theme.colors.grey2};
                        }
                    }
                }
            }
        }

        .Collapsible {
            border: unset;
            font-family: ${({ theme }) => theme.fonts.fontBase};
            color: ${({ theme }) => theme.colors.grey5};
            .Collapsible__trigger {
                font-weight: bold;

                :after {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='11' viewBox='0 0 26 14' fill='none'%3E %3Cpath d='M1 13L13 1L25 13' stroke='red' stroke-width='2' stroke-linejoin='bevel'/%3E %3C/svg%3E");
                    height: ${rem('11px')};
                    width: ${rem('19px')};
                }
                &:focus-visible {
                    outline: 3px solid ${({ theme }) => theme.colors.focus} !important;
                }
            }
            .Collapsible__contentInner {
                background: ${({ theme }) => theme.colors.trimPageModelNameBackground};
                .mainInfo {
                    background: ${({ theme }) => theme.colors.trimPageModelNameBackground};
                    .detailsBlock {
                        .paragraph {
                            span:nth-child(2) {
                                font-weight: normal !important;
                            }
                        }
                        .priceSummary {
                            .priceInfoWrapper {
                                font-weight: bold;
                            }
                            .optionsWrapper {
                                .paragraph {
                                    span:nth-child(2) {
                                        span {
                                            font-weight: normal !important;
                                        }
                                    }
                                }
                            }
                            .totalPrice {
                                span:nth-child(2) {
                                    span {
                                        font-weight: normal !important;
                                    }
                                }
                            }
                        }
                    }
                    .carInfoHeader {
                        .title-specPack,
                        .title {
                            font-family: ${({ theme }) => theme.fonts.fontBase};
                            font-size: ${rem(22)};
                            font-weight: bold;
                            text-transform: uppercase;
                        }
                        .title-specPack {
                            color: ${({ theme }) => theme.colors.grey5};
                        }

                        .title-engineInfo {
                            font-family: ${({ theme }) => theme.fonts.fontBase};
                            font-size: ${({ theme }) => theme.fontSizes.h5};
                            color: ${({ theme }) => theme.colors.grey5};
                        }

                        .desktop {
                            .availableInWrapper {
                                font-family: ${({ theme }) => theme.fonts.fontBase};
                                color: ${({ theme }) => theme.colors.grey5};
                                font-size: ${({ theme }) => theme.fontSizes.h5};
                                font-weight: normal;
                                .availableInDate {
                                    color: ${({ theme }) => theme.colors.grey5};
                                }
                            }
                        }
                    }
                }
                .finance-summary--grid {
                    background: unset;
                    .finance-summary--row-2 {
                        background: unset;
                    }
                    .indent-style {
                        background: ${({ theme }) => theme.colors.grey8};
                    }
                    span {
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                        font-size: ${({ theme }) => theme.fontSizes.h5};
                        color: ${({ theme }) => theme.colors.grey5};
                    }
                    .finance-summary__legalText2 {
                        span {
                            font-weight: normal !important;
                        }
                    }
                }
            }
        }
    }

    .priceWrap {
        &--priceLabel {
            font-size: ${rem(12)};
            color: ${({ theme }) => theme.colors.black};
        }
        &--price {
            font-family: ${({ theme }) => theme.fonts.fontBase};
            font-size: ${rem(18)};
        }
    }

    .priceWrap--cashPrice .priceWrap--price {
        font-size: ${rem(18)};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }
    .priceWrap--monthlyPrice .priceWrap--price {
        font-size: ${rem(18)};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .priceWrap--container {
        margin: ${rem(10)} 0 0 0;
        width: fit-content;
    }

    .price-and-date {
        .text {
            font-size: ${rem(14)};
            color: ${({ theme }) => theme.colors.grey2};
        }

        .date {
            font-size: ${rem(14)};
            color: ${({ theme }) => theme.colors.grey21};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }
    }

    .deal-steps-flow {
        max-height: ${rem(170)};

        ul {
            &:before {
                display: none;
            }
            li {
                img.none {
                    border-color: ${({ theme }) => theme.colors.grey3} !important;
                }
                span {
                    color: ${({ theme }) => theme.colors.grey5} !important;
                }
            }
        }
    }

    .deal-steps-flow .step-container {
        .text {
            color: ${({ theme }) => theme.colors.black};
        }

        .icon.ok {
            padding: 0;
            background: ${({ theme }) => theme.colors.blue2};
            border-color: ${({ theme }) => theme.colors.blue2};
        }
    }

    .buttons {
        .continue {
            height: fit-content;
            align-self: center;
        }
    }

    .deal .deal-content .buttons {
        flex-wrap: wrap;
    }

    .deal .deal-content .buttonsOffer {
        justify-content: flex-end;
    }

    .deal .deal-content .buttons-box {
        padding: ${rem(8)} ${rem(20)} ${rem(20)} ${rem(20)};
    }
  
    .deal .deal-content .order-number div {
        font-size: ${rem(14)};
        padding: ${rem(15)} ${rem(25)};
        background: ${({ theme }) => theme.colors._3000ShadesOfGrey};
    }

    .deal-saved-text {
        width: 100%;
        text-align: left;
        margin: unset;
        margin-bottom: ${rem(6)};
        font-size: ${rem(14)};
        font-family: ${({ theme }) => theme.fonts.fontBase};
        color: ${({ theme }) => theme.colors.grey5};
        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(70)};
        }
    }

    .deal .deal-content .buttons button.continue {
        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(45)};
        }
    }

    .view-more {
        background: transparent;
        margin-top: ${rem(-10)};
        padding-top: 0;
        padding-bottom: ${rem(40)};
    }
    .details-link {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};

        @media (min-width: ${breakpoints.md}px) {
            display: block;
            margin-left: auto;
            padding: 0;
            margin-right: ${rem(105)};
        }
    }

    .deal .deal-content .car-header {
        @media (max-width: ${rem(600)}) {
            flex-wrap: wrap;
        }
    }

    .deal .deal-content .buttons button.continue.continue__large {
        margin-right: ${rem(45)};
    }

    .buttons.deal-buttons-sol .buttons-box {
        width: 100%;
        flex-flow: row wrap;
    }
`;
